import React from 'react';
import { EAA_Item, EAA_ItemContainer, EAA_Row, EAA_TitleText, EAA_ErrorText, EAA_Add_Btn, EAA_Upload, EAA_Date } from '~/components/EditAndAddItem';
import * as getTime from '~/skills/getTime';

const emptyBody = {
  start_date: '',
  end_date: '',
  ship_lic_upload_files: [],
};

const App = props => {
  const { titleWidth, disabled, checkChange, changeData, data } = props;
  const ary = data.sub1 || [];
  if (ary.length === 0)ary.push({ ...emptyBody });

  const saveSub = dataAry => {
    changeData({ label: 'sub1', data: dataAry });
  };

  const addRow = () => {
    ary.push({ ...emptyBody });
    saveSub(ary);
  };

  const delRow = n => {
    ary.splice(n, 1);
    saveSub(ary);
  };

  const renderAry = [];
  for (let i = 0; i < ary.length; i++) {
    const isFirst = i === 0;
    renderAry.push(
      <EAA_Row key={`Page_ForeignBoat_sub1_1_${i}`}>
        <EAA_Item>
          <EAA_ItemContainer>
            <EAA_TitleText width={titleWidth} text='' />
            <div style={{ flex: 1, fontSize: 16, fontWeight: 400, color: 'rgba(0, 0, 0, 0.54)', marginRight: 12 }}>船級許可證明</div>
            <div style={{ flex: 1, fontSize: 16, fontWeight: 400, color: 'rgba(0, 0, 0, 0.54)', marginRight: 12 }}>許可期間起始</div>
            <div style={{ flex: 1, fontSize: 16, fontWeight: 400, color: 'rgba(0, 0, 0, 0.54)', marginRight: 12 + 150 }}>許可期間結束</div>
          </EAA_ItemContainer>
        </EAA_Item>
      </EAA_Row>,
    );
    renderAry.push(
      <EAA_Row key={`Page_ForeignBoat_sub1_2_${i}`} style={{ marginTop: 0 }}>
        <EAA_Item>
          <EAA_ItemContainer>
            <EAA_TitleText width={titleWidth} text={isFirst ? '船級許可' : ''} bol={isFirst} />
            <EAA_Upload displayBorder disabled={disabled} marginRight={8} value={ary[i].ship_lic_upload_files} onChange={data => { ary[i].ship_lic_upload_files = data; saveSub(ary); }} />
            <EAA_Date displayBorder disabled={disabled} marginRight={8} value={getTime.returnDate(ary[i].start_date)} onChange={data => { ary[i].start_date = getTime.getType3Time(data); saveSub(ary); }} />
            <EAA_Date displayBorder disabled={disabled} marginRight={8} value={getTime.returnDate(ary[i].end_date)} onChange={data => { ary[i].end_date = getTime.getType3Time(data); saveSub(ary); }} />
            <EAA_Add_Btn disabled={disabled} del={i > 0} onClick={(i > 0) ? () => delRow(i) : () => addRow()} />
          </EAA_ItemContainer>
          {/* {errorAry[0] && <EAA_ErrorText marginLeft={errorLeft} text='帳號需為 1 ~ 100 英數字。' />} */}
        </EAA_Item>
      </EAA_Row>,
    );
  }
  return renderAry;
};
export default App;
